import i18n from 'shared/i18n';

import HandshqApp from '../handshq-app';

HandshqApp.MasterActivity = (function () {
  function MasterActivity(masterActivity) {
    if (this instanceof HandshqApp.MasterActivity) {
      this.element = $(masterActivity);
      this.form = this.element.find('form');
      this.checkbox = this.form.find(':checkbox');
      this.remoteId = $(this.checkbox).val();
      this.labelName = this.element.find('.master-activity__name');
      this.editButton = this.element.find('.activity__edit');
      this.versionInfoElement = this.element.find('.master-activity__version');
      this.formData = {};
      this.editButtonSpinnerIsActive = false;
      this.interactionTimer;
      this.removeUnavailableModal = $('.remove-master-activity');
      this.editedWarningModal = $('.edited-risk-assessment-warning');

      this.init();
    } else {
      throw new Error('HandshqApp.MasterActivity invoked without new');
    }
  }

  // private functions can be provided here if needed

  MasterActivity.prototype = {
    init() {
      this.generateFormData();
      this.respondToCheckboxChange();
      this.updateEditButtonStatus();
      this.triggerCheckboxFromName();
    },

    // applies to all master activities (including self) with same remote ID
    forAllSimiliarMasterActivities(applyCallback) {
      const _this = this;
      $(HandshqApp.masterActivities).each((i, masterActivity) => {
        if (masterActivity.remoteId === _this.remoteId) {
          applyCallback(masterActivity);
        }
      });
    },

    showSpinnerWhileCreating() {
      const _this = this;
      if (!_this.hasActivityFormData()) {
        _this.editButton.on('click', (event) => {
          event.preventDefault();
          _this.setEditButtonSpinnerActiveState(true);
        });
      }
    },

    toggleAllSimiliarMasterActivities() {
      const _this = this;

      this.forAllSimiliarMasterActivities((masterActivity) => {
        if (_this !== masterActivity) {
          masterActivity.toggleChecked();
        }
        masterActivity.updateEditButtonStatus();
        masterActivity.updateVersionStatus();
      });
    },

    respondToCheckboxChange() {
      const _this = this;

      this.checkbox.change(() => {
        clearTimeout(_this.interactionTimer);

        if (_this.shouldPreventUntickingEditedActivity()) {
          _this.revertCheckboxAndShowModal();
          return;
        }

        _this.executeConfirmationFlow();
      });
    },

    shouldPreventUntickingEditedActivity() {
      return (
        !this.checkboxIsChecked() &&
        this.hasActivityFormData() &&
        this.isActivityEdited()
      );
    },

    revertCheckboxAndShowModal() {
      this.checkbox[0].checked = true;
      this.handleEditedActivityUntick();
    },

    scheduleRemoteObjectUpdate() {
      this.interactionTimer = setTimeout(
        this.createOrDestroyRemoteObject.bind(this),
        1000,
      );
    },

    handleUnavailableActivity() {
      if (!this.checkboxIsChecked() && this.hasActivityFormData()) {
        const _this = this;
        const cancelButton = this.removeUnavailableModal.find(
          '[data-action="cancel"]',
        );
        const confirmButton = this.removeUnavailableModal.find(
          '[data-action="confirm"]',
        );

        cancelButton[0].onclick = function () {
          _this.toggleChecked();
          _this.updateEditButtonStatus();
          _this.toggleAllSimiliarMasterActivities();
        };
        confirmButton[0].onclick = function () {
          _this.removeUnavailableActivity();
        };

        this.removeUnavailableModal.modal('show');
      }
    },

    removeUnavailableActivity() {
      const _this = this;

      this.interactionTimer = setTimeout(this.destroyRemoteActivity(), 1000);
      this.removeUnavailableModal.modal('hide');
      this.element.remove();

      this.forAllSimiliarMasterActivities((masterActivity) => {
        if (_this !== masterActivity) {
          masterActivity.element.remove();
        }
      });
    },

    createOrDestroyRemoteObject() {
      if (this.checkboxIsChecked() && !this.hasActivityFormData()) {
        this.createRemoteActivity();
      } else if (!this.checkboxIsChecked() && this.hasActivityFormData()) {
        this.destroyRemoteActivity();
      }
    },

    createRemoteActivity() {
      const _this = this;
      $.ajax({
        type: 'POST',
        url:
          '/projects/' +
          _this.formData.project +
          '/master_activities/' +
          _this.formData.master_activity +
          '/activities',
        dataType: 'json',
        success(response) {
          _this.activityGenerated(response.id);
        },
      });
    },

    destroyRemoteActivity() {
      const _this = this;
      $.ajax({
        url:
          '/projects/' +
          _this.formData.project +
          '/activities/' +
          _this.formData.activity,
        dataType: 'json',
        method: 'delete',
        success: _this.activityDestroyed.bind(_this),
      });
    },

    activityGenerated(activityId) {
      const _this = this;
      this.forAllSimiliarMasterActivities((masterActivity) => {
        masterActivity.updateActivityFormData(activityId);
        masterActivity.updateEditButtonUrl();
        masterActivity.editButton.off();

        if (masterActivity === _this && _this.editButtonSpinnerIsActive) {
          _this.setEditButtonSpinnerActiveState(false);
          // redirect if already clicked and waiting to proceed to edit.
          window.location = _this.editButton.attr('href');
        }
      });
    },

    activityDestroyed() {
      this.forAllSimiliarMasterActivities((masterActivity) => {
        masterActivity.resetActivityFormData();
        masterActivity.editButton.attr('href', '#');
        masterActivity.editButton.find('.activity__edited-icon').remove();
        masterActivity.editButton.find('.activity__edited-text').text('Edit');
        masterActivity.editButton.attr('data-updated', false);
      });
    },

    toggleChecked() {
      if (!this.checkboxIsChecked()) {
        this.checkbox.prop('checked', true);
      } else {
        this.checkbox.prop('checked', false);
      }
    },

    updateEditButtonStatus() {
      if (this.checkboxIsChecked()) {
        this.editButton.attr('data-disabled', false);
      } else {
        this.editButton.attr('data-disabled', true);
      }
    },

    setEditButtonSpinnerActiveState(shouldBeActive) {
      const spinner = this.editButton.find('.spinner');

      shouldBeActive ?
        spinner.removeClass('tw-hidden')
      : spinner.addClass('tw-hidden');

      this.editButtonSpinnerIsActive = shouldBeActive;
    },

    updateEditButtonUrl() {
      let url;
      if (this.hasActivityFormData()) {
        url =
          '/projects/' +
          this.formData.project +
          '/activities/' +
          this.formData.activity +
          '/edit?trade=' +
          this.formData.trade;
      } else {
        url = '#';
      }

      this.editButton.attr('href', url);
    },

    updateActivityFormData(activityId) {
      this.form.find('#activity').val(activityId);
      this.formData.activity = activityId;
    },

    resetActivityFormData() {
      this.form.find('#activity').removeAttr('value');
      this.formData.activity = '';
    },

    triggerCheckboxFromName() {
      this.labelName.on('click', function () {
        $(this).parent().find('label').click();
      });
    },

    updateVersionStatus() {
      this.setVersionVisualisation({
        isLatestVersion: this.checkboxIsChecked(),
      });
    },

    setVersionVisualisation({ isLatestVersion }) {
      if (isLatestVersion) {
        this.versionInfoElement.find('.circle').addClass('latest-version');

        this.versionInfoElement
          .find('.version-text')
          .addClass('latest-version')
          .text(i18n.t('shared.latestVersion', { ns: 'common' }));
      } else {
        this.versionInfoElement.find('.circle').attr('class', 'circle');

        this.versionInfoElement
          .find('.version-text')
          .attr(
            'class',
            'version-text tw-text-xs tw-font-semibold tw-tracking-wide',
          )
          .text('');
      }
    },

    generateFormData() {
      const _this = this;
      this.form.find('input').each((i, el) => {
        _this.formData[el.name] = $(el).val();
      });
    },

    hasActivityFormData() {
      return this.formData.activity !== '';
    },

    checkboxIsChecked() {
      return this.checkbox[0].checked;
    },

    activityAvailable() {
      return this.checkbox.attr('data-available') === 'true';
    },

    isActivityEdited() {
      return this.editButton.attr('data-updated') === 'true';
    },

    handleEditedActivityUntick() {
      this.updateEditedWarningModalContent();
      this.setupEditedWarningModalEvents();
      this.editedWarningModal.modal('show');
    },

    updateEditedWarningModalContent() {
      const header = this.editedWarningModal.find('[data-identity="header"]');

      header.text(
        i18n.t('shared.deleteNameConfirmation', {
          name: this.labelName.text().trim(),
          ns: 'common',
        }),
      );
    },

    setupEditedWarningModalEvents() {
      this.setCheckboxesDisabled(true);
      this.setupModalButtons();
      this.setupModalCleanup();
    },

    setupModalButtons() {
      const cancelButton = this.editedWarningModal.find(
        '[data-action="cancel"]',
      );
      const confirmButton = this.editedWarningModal.find(
        '[data-action="confirm"]',
      );

      cancelButton
        .off('click')
        .on('click', () => this.handleEditedWarningCancel());
      confirmButton
        .off('click')
        .on('click', () => this.handleEditedWarningConfirm());
    },

    setupModalCleanup() {
      const _this = this;
      this.editedWarningModal.off('hidden.bs.modal.editedWarning');
      this.editedWarningModal.on('hidden.bs.modal.editedWarning', () => {
        _this.setCheckboxesDisabled(false);
      });
    },

    handleEditedWarningCancel() {
      this.editedWarningModal.modal('hide');
    },

    handleEditedWarningConfirm() {
      this.editedWarningModal.modal('hide');
      this.proceedWithUntickingEditedActivity();
    },

    proceedWithUntickingEditedActivity() {
      this.uncheckBox();
      this.executeConfirmationFlow();
    },

    executeConfirmationFlow() {
      this.showSpinnerWhileCreating();
      this.toggleAllSimiliarMasterActivities();

      if (!this.activityAvailable()) {
        this.handleUnavailableActivity();
        return;
      }

      this.scheduleRemoteObjectUpdate();
    },

    uncheckBox() {
      this.checkbox[0].checked = false;
    },

    setCheckboxesDisabled(isDisabled) {
      $('.master-activity input[type="checkbox"]').prop('disabled', isDisabled);
    },
  };

  return MasterActivity;
})();
